<template>
  <v-card outlined :loading="loading" :min-width-400="$vuetify.breakpoint.smAndUp" :min-width-300="$vuetify.breakpoint.xsOnly">
    <v-snackbar v-model="snackbar.show" top :color="snackbar.color">
      {{ snackbar.text }}
    </v-snackbar>

    <v-dialog v-model="tcDialog"></v-dialog>

    <v-card-title>
      <div class="subtitle-1">{{ companyName }}</div>
    </v-card-title>
    <v-card-subtitle>
      <div class="ml-4 headline">Sign up</div>
    </v-card-subtitle>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Email"
          name="email"
          type="text"
          autofocus
          :rules="[rules.required, rules.email]"
          v-model="data.email"
          prepend-inner-icon="email"
          outlined
        ></v-text-field>
        <v-text-field
          label="Password"
          name="password"
          type="password"
          :rules="[rules.required]"
          v-model="data.password"
          prepend-inner-icon="lock"
          outlined
        ></v-text-field>
        <v-text-field
          label="Confirm password"
          name="password2"
          type="password"
          :rules="[rules.required]"
          :error-messages="matchPassword"
          v-model="password2"
          prepend-inner-icon="lock"
          outlined
        ></v-text-field>
        <v-checkbox v-model="termsAgreed" label="Have read and agree to the"></v-checkbox>
        <div class="ml-8 mb-2" style="margin-top:-10px">
          <a target="_blank" href="/terms.html">Terms of Use</a> and
          <a target="_blank" href="/privacy.html">Privacy Policy</a>.
        </div>
        <v-col cols="12">
          <v-btn :disabled="!valid || !termsAgreed" large block color="success lighten-1" @click="signup">Sign Up</v-btn>
        </v-col>
        <v-col cols="12">
          <v-btn large block text @click="$emit('set-auth-state', {state: 'signin'})">Has account?</v-btn>
        </v-col>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import UserService from '@/services/UserService.js'

export default {
  name: 'Signup',
  data: () => ({
    loading: false,
    valid: false,
    data: { email: '', password: '' },
    password2: '',
    termsAgreed: false,
    snackbar: {
      show: false,
      color: '',
      text: ''
    }
  }),
  computed: {
    ...mapGetters([
      'rules',
      'companyName'
    ]),
    matchPassword () {
      return this.data.password === this.password2 ? '' : 'Password must match'
    }
  },
  methods: {
    signup () {
      this.loading = true
      UserService.signup(this.data)
        .then(resp => {
          this.loading = false
          this.$refs.form.reset()
          this.$emit('set-auth-state', {
            state: 'activate',
            email: resp.data.email,
            message: 'Sign up sucessful! Please check and verify your email.'
          })
        })
        .catch(err => {
          console.error(err)
          this.loading = false
          this.snackbar.color = 'error'
          this.snackbar.text = err.response.data.detail
          this.snackbar.show = true
        })
    }
  }
}
</script>
